import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { LocationService } from 'src/app/admin/location/shared/services/location.service';
import { State } from 'src/app/dashboard/state';
import { LocationsDropDownCheckBoxTreeViewComponent } from 'src/app/shared/modalpopup/locations-drop-down-treeview/locations-drop-down-check-box-tree-view-component';
import { LocationSelector } from 'src/app/shared/models/location-selector/location-selector-model';
import { LocationSelectorItem } from '../../models/location-selector/location-selector-item-model';
import { LocationDropDownModel } from '../../models/locations-drop-down-list.model';

import { LocationSelectorInfo } from 'src/app/admin/user/shared/models/locationSelectorModel';

@Component({
  selector: 'app-location-selector',
  templateUrl: './location-selector.component.html',
  styleUrls: ['./location-selector.component.scss']
})
export class LocationSelectorComponent implements OnInit {

  public checkedLocationIds: number[] = [-1];
  public userLocationIds: number[] = [-1];
  public expandedKeys: number[] = [];

  public selectorOpened: boolean = false;
  public disableSelector: boolean = false;

  @Input() dispatchStateEvent: boolean = true;

  @Input() selectedLocationName?: string = "Select";
  @Input() selectedLocationId?: number = 0;

  @Input() labelText: string = '';
  @Input() hoverText: string = '';

  @Input() isIncludeFloatLocation: boolean = true;
  @Input() isDisableParentClick: boolean = false;
  @Input() page: string = "";
  @Input() hideBranchLess: boolean = false;

  @Input() isLobby: boolean = false;

  @Input() selectableTypes: number[] = []; // an array of location types to be made selectable
  @Input() selectorDisabled: boolean = false;

  @Output() onChange: EventEmitter<LocationSelectorInfo> = new EventEmitter();
  @Output() onLocationsData = new EventEmitter<LocationSelector>();

  public locationHierachy: LocationSelector = {
    locations: [],
    locationsFlatData: []
  };

  @ViewChild(LocationsDropDownCheckBoxTreeViewComponent) locationsDropDownCheckBoxTreeViewComponent?: LocationsDropDownCheckBoxTreeViewComponent;
  constructor(private locationService: LocationService, private elementRef: ElementRef, private store: Store<State>) { }

  ngOnInit(): void {

    this.locationService.getSelectorLocationHierachy(this.isDisableParentClick,
      this.isIncludeFloatLocation,
      this.hideBranchLess,
      false,this.isLobby).subscribe({
        next: (locationsHierachy) => {

          this.locationHierachy = locationsHierachy as LocationSelector;
          this.onLocationsData.emit(this.locationHierachy);

          if (this.selectableTypes.length > 0)
            this.locationHierachy.locations[0] = this.makeSelectableByLocationType(this.locationHierachy.locations[0]);

          if (this.locationHierachy.locations.length > 0 && this.locationHierachy.locations[0].items == null) {
            this.disableSelector = true;
            this.selectedLocationName = "NBA";
          } else if (this.selectedLocationName == null && this.selectedLocationId != null) {
            // if a location name is not passed in as an input, we set it using the locationId
            this.selectedLocationName = this.locationHierachy.locationsFlatData.find(l => l.locationId == this.selectedLocationId)?.locationName || '';
          }

          this.addExpandListItem(locationsHierachy.locations);

        },
        error: () => { }
      });

    this.setDropDownState();
  }

  private makeSelectableByLocationType(locations: LocationSelectorItem) {

    locations.isSelectable = this.selectableTypes.includes(locations.locationTypeId);

    if (locations.hasChild) {
      locations.items?.forEach(i => this.makeSelectableByLocationType(i));
    }

    return locations;
  }

  private setDropDownState() {
    this.disableSelector = this.selectorDisabled;
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      this.selectorOpened = false;
    }
  }

  public closeDropDown() {
    this.selectorOpened = false;
  }

  public onItemSelected(data: LocationSelectorInfo) {
    this.selectorOpened = false;
    this.onChange.emit(data);
  }

  private addExpandListItem(treeItem: LocationDropDownModel[]) {
    treeItem.forEach(item => {
      if (item.items && item.items.length > 0) {
        this.expandedKeys.push(item.locationId);
        this.addExpandListItem(item.items)
      }
    });
  }

  public locationClick() {
    if (!this.selectorDisabled) {
      this.selectorOpened = !this.selectorOpened;
    }
  }

}

